// extracted by mini-css-extract-plugin
module.exports = {"component":"anchor-component--2cRpN"};